import {TelemetryEventName} from 'TelemetryConstants';

export const AWSBlacklistConfig: ReadonlyArray<TelemetryEventName> = [
  // Add blacklisted event names here
  TelemetryEventName.WITHDRAW_BANK_PAGE_CTA_CLICK,
  TelemetryEventName.WITHDRAW_BANK_PAGE_LOAD,
  TelemetryEventName.STORE_BANK_LINKING_COMPLETE,
  TelemetryEventName.STORE_BANK_LINKING_FAIL,
  TelemetryEventName.STORE_BANK_LINKING_ACCOUNT_INFO_PAGE_SHOWN,
  TelemetryEventName.STORE_BANK_LINKING_ACCOUNT_INFO_PAGE_SUBMIT_CLICK,
];
